import { render, staticRenderFns } from "./PageMenu.vue?vue&type=template&id=5528f200"
import script from "./PageMenu.vue?vue&type=script&lang=ts"
export * from "./PageMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports